<div mat-dialog-content class="alerts" [ngClass]="{
    'alert-success': data.type === 'alert-success',
    'alert-danger': data.type === 'alert-danger',
    'alert-info': data.type === 'alert-info',
    'alert-warning': data.type === 'alert-warning'
  }" style="padding:5px;">
  <div class="alert-container">
    <span class="alert-message col-md-5" style="text-align:left;">
      <span *ngIf="data.type == 'alert-danger'">
        Alert
      </span>

      <span *ngIf="data.type == 'alert-success'">
     Message Info
      </span>

      <span *ngIf="data.type == 'alert-warning'">
         Warning
      </span>

      <span *ngIf="data.type == 'alert-info'">
        Message Info
      </span>


      </span>
    <span class="alert-header col-md-7">
      <button class="closebutton btn-close" type="button" (click)="close()"></button>
    </span>
  </div>
  <div class="message-container" *ngIf="data.type == 'alert-warning' || data.type == 'alert-success'||data.type == 'alert-danger'">
    <div class="row">
    <div class="col-md-1">
      <span *ngIf="data.type == 'alert-danger'">
        <i class="fa fa-circle-exclamation fa-2x"></i> 
      </span>
      <span *ngIf="data.type == 'alert-success'">
        <i class="fa fa-circle-check fa-2x"></i> 
      </span>
  
      <span *ngIf="data.type == 'alert-warning'">
        <i class="fa fa-warning fa-2x red"></i>
        
      </span>
    </div>

    <div class="col-md-11 text-left">    {{ data.message }}</div>
  </div>
 
  </div>
  <div class="message-container" *ngIf="data.type == 'alert-info'" >
   <div class="row">
    <div class="col-md-1">
      <span *ngIf="data.type == 'alert-info'">
        <i class="fa fa-info-circle fa-2x"></i> 
       </span>
    </div>
    <div class="col-md-11 text-left">
      {{ data.message }}
    </div>

   </div> 
    <div class="col-md-12 text-right">
      <button class="btn btn-primary btn-success" type="submit"(click)="closeDialog('yes')">Ok</button>
      <button class="btn btn-primary btn-danger" type="button" (click)="closeDialog('cancel')">Cancel</button>
    </div>
  </div>
</div>